<div class="container-lg container-contact">
    <h1>Besoin de plus de renseignement?</h1>
    
    <h2 class="h2">Vous pourrez bentôt envoyer directement des messages depuis cette page</h2>
    <p class="waiting mb-0">En attendant n'hésitez pas à nous appeler ou nous envoyer un mail.</p>

    <h3 class="h3">Pour contacter Jordan le coach</h3>
    <p class="by-phone">par téléphone: <span class="num-tel">0616346696</span></p>
    <p class="by-mail">ou par mail: <a class="btn btn-sm" role="button" href="mailto:heat.training13@gmail.com">heat.training13@gmail.com</a></p>
    
    <h3 class="h3">Pour contacter Manon la diététicienne</h3>
    <p class="by-phone">par téléphone: <span class="num-tel">0615035428</span></p>
    <p class="by-mail by-mail-last">ou par mail: <a class="btn btn-sm" role="button" href="mailto:manon.geynet@outlook.fr">manon.geynet@outlook.fr</a></p>

    <h2 class="h2">Venez directement nous rendre visite dans notre salle</h2>
    <p class="waiting">Comment nous trouver ?</p>
    <div class="map-container d-flex row">
        <div class="map col-12 col-xl-6">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.9710723199873!2d4.9408184157273265!3d43.8356977486282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12b5fb45503f8b21%3A0x5f2d4e718f4767bc!2sHeat%20Training!5e0!3m2!1sfr!2sfr!4v1616090737206!5m2!1sfr!2sfr" allowfullscreen="" loading="lazy"></iframe>
        </div>
        <div class="text-map flex flex-column justify-center col-12 col-xl-6 my-3">
            <p class="mb-3">3 place des martinets<br>13 670 Saint Andiol</p>
        </div>
    </div>
</div>
